import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import PrivateLayout from '../templates/PrivateLayout'
import { api } from '../axiosInstance/axiosInstance'
import { useAuth } from '../context/AuthProvider'
import { ErrorMessage } from '@hookform/error-message'

export default function DeleteAccount() {
  const { user, logout } = useAuth()
  const { register, handleSubmit, formState: { errors }, setError } = useForm()
  
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Apagar conta | Fonoaudiologia na Prática";

    return () => {
      document.title = previousTitle;
    };
  }, []);
  const handleDeleteAccount = async () => {

    const confirmDelete = window.confirm('Tem certeza que deseja excluir sua conta? Esta ação não pode ser desfeita.');
    if (!confirmDelete) {
      return; // Se o usuário cancelar, não faz nada
    }
    try {
      const response = await api.delete("/user")
      alert('Conta deletada com sucesso!')
      localStorage.clear() // Limpar dados do localStorage para logout
      logout()
    } catch (error) {
      alert('Erro ao deletar conta, por favor tente novamente.')
    }
  }

  const onSubmit = async (data: any) => {
    // O campo de senha já está validado pelo react-hook-form
    if (!data.password) {
      return
    }


    const formatUser = {
      email: user?.email,
      password: data.password
    }
    try {

      const response = await api.post('/login', formatUser)
      handleDeleteAccount()
    } catch (error) {
      setError('password', { message: 'Senha incorreta' })
    }
  }

  return (
    <PrivateLayout>
      <div className="flex flex-col items-center p-6 bg-white space-y-6 min-h-screen -20 px">
        <div className="text-gray-700 text-lg font-medium">
          <p className="mb-4">
            Apagar sua conta vai:
            <ul className="list-disc pl-5">
              <li>Apagar seus dados de conta e foto do perfil.</li>
              <li>Apagar todos os seus pacientes do FonotherApp.</li>
              <li>Apagar todos os dados de atendimentos.</li>
              <li>Apagar qualquer registro criado por você.</li>
            </ul>
          </p>

          <form onSubmit={handleSubmit(onSubmit)} className="w-full">
            <label htmlFor="password" className="block text-gray-700 mb-2">Confirmar sua senha</label>
            <input
              type="password"
              id="password"
              placeholder="Confirme sua senha"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary mb-4"
              {...register("password", { required: "A senha é obrigatória" })}
            />

            {errors.password && typeof errors.password === 'object' && 'message' in errors.password && (
              <ErrorMessage name='password' errors={errors} render={({ message }) => <p className="text-red-600">{message}</p>} />
            )}


            <button
              type="submit"
              className="w-full py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
            >
              Apagar Conta
            </button>
          </form>
        </div>
      </div>
    </PrivateLayout>
  )
}
